import { AssertIsFunctionException } from './assert-is-function.exception';
import { isFunction } from '@pct-ts/typeguard';

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export function assertIsFunction(value: unknown, message: string): asserts value is Function {
  if (!isFunction(value)) {
    throw new AssertIsFunctionException(`Not a function: ${message}`);
  }
}
